import * as XLSX from "xlsx";

const listToText = (items) => {
  if (!Array.isArray(items)) return "";

  return items
    .filter(
      (item) =>
        item !== null &&
        item !== undefined &&
        String(item).trim() !== ""
    )
    .map((item) => String(item).trim())
    .join("; ");
};

const actionToSummary = (action) => {
  if (!action) return "";

  const summaryParts = [
    action.action || "",
    action.owner ? `Owner: ${action.owner}` : "",
    action.dueDate ? `Due: ${action.dueDate}` : "",
    action.priority ? `Priority: ${action.priority}` : "",
    action.status ? `Status: ${action.status}` : "",
  ].filter(Boolean);

  return summaryParts.join(" | ");
};

export const buildAARExportRows = (projects = []) => {
  return projects.map((project) => {
    const actions = Array.isArray(project.actions) ? project.actions : [];

    return {
      ProjectID: project.id ?? "",
      Title: project.title || "",
      Subtitle: project.subtitle || "",
      Type: project.type || "",
      Year: project.year || "",
      Area: project.area || "",
      Status: project.status || "",
      Location: project.location || "",
      Date: project.date || "",
      Overview: project.overview || "",
      Safety: project.performance?.safety || "",
      Quality: project.performance?.quality || "",
      Cost: project.performance?.cost || "",
      Schedule: project.performance?.schedule || "",
      WhatWentWell: listToText(project.whatWentWell),
      Improvements: listToText(project.improvements),
      LessonsLearned: listToText(project.lessonsLearned),
      ActionCount: actions.length,
      ActionSummary: actions.map(actionToSummary).filter(Boolean).join("; "),
    };
  });
};

export const exportAARToExcel = (projects = [], filename = "AAR-Export.xlsx") => {
  if (!projects.length) {
    return;
  }

  const rows = buildAARExportRows(projects);
  const worksheet = XLSX.utils.json_to_sheet(rows);
  const workbook = XLSX.utils.book_new();

  XLSX.utils.book_append_sheet(workbook, worksheet, "AAR Data");
  XLSX.writeFile(workbook, filename);
};

export default exportAARToExcel;
